export const STATUS_ROUTINE = Object.freeze({
	PENDING_TO_EXECUTE: 'PENDING_TO_EXECUTE',
	EXECUTING: 'EXECUTING',
	ACCOMPLISHED: 'ACCOMPLISHED',
});
